import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/sp-core/:parkingId/files/photos/:photoId/get-signed-url/';

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    photoId: string;
}
const queryFn = ({ parkingId, photoId }: DTO): Promise<{ url: string }> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, photoId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as PHOTO_URL_RESOURCE, useQueryHook as useGetPhotoUrl };
